import React, { Component } from 'react';
import { Container, Accordion, Icon, Table, Modal, Input, Dimmer, Header, Button, Dropdown, Popup } from 'semantic-ui-react';
import { PtInput, PtSelect, PtDateInput, TextSelect } from '../../../grit-utilities';
import DropdownLib from '../../../DropdownLib';
import 'semantic-ui-css/semantic.min.css';
import ScrollArea from 'react-scrollbar';
import '../../../index.css';
import config from '../../../config.json';
import $ from 'jquery';
import '../../../index.css';
import { LabelFactory } from '@blueprintjs/core';

export default class Condition extends Component {
    constructor(props) {
        super(props);

        this.state = {
            ...this.props.pointModel,
            selectedIndex: 1
        }
    }
    render() {
        const { severityOptions } = DropdownLib.getDropdowns().Signs_Condition;
        const PriorityDate = this.state.Condition.conditionData.map((d, i) => {
            if (this.state.selectedIndex === d.key) {
                return (
                    <PtDateInput key={i} label='Priority Date'
                        placeholder="Not Available" whichInput="firsttb" inputType="hwy" name="PriorityDate"
                        disabled={this.props.disabled}
                        value={d.PriorityDate ? d.PriorityDate.slice(0, 10) : null}
                        onChange={(date) => this.onChangeDate(date, "PriorityDate")} />
                )

            }
        })
        const PriorityHigh = this.state.Condition.conditionData.map((d, i) => {
            if (this.state.selectedIndex === d.key)
                return (
                    <div key={i}
                        style={{ 'marginLeft': '10%' }}>
                        <input
                            onChange={this.onCheckedChange}
                            checked={d.PriorityHigh}
                            name='PriorityHigh'
                            type="checkbox" /> <label>High Priority</label>
                    </div>
                )
        })
        const PriorityComments = this.state.Condition.conditionData.map((d, i) => {
            if (this.state.selectedIndex === d.key)
                return (
                    <PtInput key={i} inputType="text"
                        label="Priority Comment"
                        value={d.PriorityComments === null ? '' : d.PriorityComments}
                        onChange={this.onInputChange} name="PriorityComments" disabled={this.props.disabled} />
                )
        })

        const PriorityKnockdown = this.state.Condition.conditionData.map((d, i) => {
            if (this.state.selectedIndex === d.key)
                return (

                    <div key={i}
                        style={{ 'marginLeft': '10%' }}>
                        <input
                            onChange={this.onCheckedChange}
                            checked={d.PriorityKnockdown}
                            name='PriorityKnockdown'
                            type="checkbox" /> <label>Knockdown</label>
                    </div>
                )
        })
        const PriorityMissing = this.state.Condition.conditionData.map((d, i) => {
            if (this.state.selectedIndex === d.key)
                return (

                    <div key={i}
                        style={{ 'marginLeft': '10%' }}>
                        <input
                            onChange={this.onCheckedChange}
                            checked={d.PriorityMissing}
                            name='PriorityMissing'
                            type="checkbox" /> <label>Missing</label>
                    </div>
                )
        })
        const PriorityCondition = this.state.Condition.conditionData.map((d, i) => {
            if (this.state.selectedIndex === d.key)
                return (

                    <div key={i}
                        style={{ 'marginLeft': '10%' }}>
                        <input
                            onChange={this.onCheckedChange}
                            checked={d.PriorityCondition}
                            name='PriorityCondition'
                            type="checkbox" /> <label>Condition</label>
                    </div>
                )
        })
        const PriorityOther = this.state.Condition.conditionData.map((d, i) => {
            if (this.state.selectedIndex === d.key)
                return (

                    <div key={i}
                        style={{ 'marginLeft': '10%' }}>
                        <input
                            onChange={this.onCheckedChange}
                            checked={d.PriorityOther}
                            name='PriorityOther'
                            type="checkbox" /> <label>Other</label>
                    </div>
                )
        })

        const VisualInspectDate = this.state.Condition.conditionData.map((d, i) => {
            if (this.state.selectedIndex === d.key) {
                return (
                    <PtDateInput key={i} label='Visual Inspection Date'
                        placeholder="Not Available" whichInput="firsttb" inputType="hwy" name="VisualInspectDate"
                        disabled={this.props.disabled}
                        value={d.VisualInspectDate ? d.VisualInspectDate.slice(0, 10) : null}
                        onChange={(date) => this.onChangeDate(date, "VisualInspectDate")} />
                )
            }
        })
        const ViPCSeverity = this.state.Condition.conditionData.map((d, i) => {
            if (this.state.selectedIndex === d.key)
                return (
                    <div>
                        <b>Panel Condition Severity</b>
                        <PtSelect key={i} options={severityOptions}
                            defaultVal={d.ViPCSeverity === null ? 0 : d.ViPCSeverity}
                            onChange={this.onChangeDropdown} name="ViPCSeverity" disabled={this.props.disabled} />
                    </div>

                )
        })
        const viPCPosHt = this.state.Condition.conditionData.map((d, i) => {
            if (this.state.selectedIndex === d.key)
                return (

                    <div key={i}
                        style={{ 'marginLeft': '10%' }}>
                        <input
                            onChange={this.onCheckedChange}
                            checked={d.ViPCPositionHeight}
                            name='ViPCPositionHeight'
                            type="checkbox" /> <label>Positon Height</label>
                    </div>
                )
        })
        const ViPCGraffiti = this.state.Condition.conditionData.map((d, i) => {
            if (this.state.selectedIndex === d.key)
                return (

                    <div key={i}
                        style={{ 'marginLeft': '10%' }}>
                        <input
                            onChange={this.onCheckedChange}
                            checked={d.ViPCGraffiti}
                            name='ViPCGraffiti'
                            type="checkbox" /> <label>Graffiti/Holes</label>
                    </div>
                )
        })
        const ViPCFade = this.state.Condition.conditionData.map((d, i) => {
            if (this.state.selectedIndex === d.key)
                return (

                    <div key={i}
                        style={{ 'marginLeft': '10%' }}>
                        <input
                            onChange={this.onCheckedChange}
                            checked={d.ViPCFade}
                            name='ViPCFade'
                            type="checkbox" /> <label>Fade/Wear</label>
                    </div>
                )
        })
        const ViPCObstructed = this.state.Condition.conditionData.map((d, i) => {
            if (this.state.selectedIndex === d.key)
                return (

                    <div key={i}
                        style={{ 'marginLeft': '10%' }}>
                        <input
                            onChange={this.onCheckedChange}
                            checked={d.ViPCObstructed}
                            name='ViPCObstructed'
                            type="checkbox" /> <label>Obstructed</label>
                    </div>
                )
        })
        const ViPCOther = this.state.Condition.conditionData.map((d, i) => {
            if (this.state.selectedIndex === d.key)
                return (

                    <div key={i}
                        style={{ 'marginLeft': '10%' }}>
                        <input
                            onChange={this.onCheckedChange}
                            checked={d.ViPCOther}
                            name='ViPCOther'
                            type="checkbox" /> <label>Other</label>
                    </div>
                )
        })
        const viPCcomment = this.state.Condition.conditionData.map((d, i) => {
            if (this.state.selectedIndex === d.key)
                return (

                    <PtInput key={i}
                        label="Comment" value={d.ViPCComment === null ? '' : d.ViPCComment}
                        onChange={this.onInputChange} name="ViPCComment" disabled={this.props.disabled} />

                )
        })


        const ViSCSeverity = this.state.Condition.conditionData.map((d, i) => {
            if (this.state.selectedIndex === d.key)
                return (
                    <div>
                        <b>Support Condition Severity</b>
                        <PtSelect key={i} options={severityOptions}
                            defaultVal={d.ViSCSeverity === null ? 0 : d.ViSCSeverity}
                            onChange={this.onChangeDropdown} name="ViSCSeverity" disabled={this.props.disabled} />
                    </div>

                )
        })
        const ViSCCorrosion = this.state.Condition.conditionData.map((d, i) => {
            if (this.state.selectedIndex === d.key)
                return (

                    <div key={i}
                        style={{ 'marginLeft': '10%' }}>
                        <input
                            onChange={this.onCheckedChange}
                            checked={d.ViSCCorrosion}
                            name='ViSCCorrosion'
                            type="checkbox" /> <label>Corrosion</label>
                    </div>
                )
        })
        const ViSCStruct = this.state.Condition.conditionData.map((d, i) => {
            if (this.state.selectedIndex === d.key)
                return (

                    <div key={i}
                        style={{ 'marginLeft': '10%' }}>
                        <input
                            onChange={this.onCheckedChange}
                            checked={d.ViSCStruct}
                            name='ViSCStruct'
                            type="checkbox" /> <label>Structural</label>
                    </div>
                )
        })
        const ViSCBreakaway = this.state.Condition.conditionData.map((d, i) => {
            if (this.state.selectedIndex === d.key)
                return (

                    <div key={i}
                        style={{ 'marginLeft': '10%' }}>
                        <input
                            onChange={this.onCheckedChange}
                            checked={d.ViSCBreakaway}
                            name='ViSCBreakaway'
                            type="checkbox" /> <label>Breakaway</label>
                    </div>
                )
        })
        const ViSCOther = this.state.Condition.conditionData.map((d, i) => {
            if (this.state.selectedIndex === d.key)
                return (

                    <div key={i}
                        style={{ 'marginLeft': '10%' }}>
                        <input
                            onChange={this.onCheckedChange}
                            checked={d.ViSCOther}
                            name='ViSCOther'
                            type="checkbox" /> <label>Other</label>
                    </div>
                )
        })
        const viSCcomment = this.state.Condition.conditionData.map((d, i) => {
            if (this.state.selectedIndex === d.key)
                return (

                    <PtInput key={i}
                        label="Comment" value={d.ViSCComment === null ? '' : d.ViSCComment}
                        onChange={this.onInputChange} name="ViSCComment" disabled={this.props.disabled} />

                )
        })

        const ViReflectSeverity = this.state.Condition.conditionData.map((d, i) => {
            if (this.state.selectedIndex === d.key)
                return (
                    <div>
                        <b>Visual Reflectivity Severity</b>
                        <PtSelect key={i} options={severityOptions}
                            defaultVal={d.ViReflectSeverity === null ? 0 : d.ViReflectSeverity}
                            onChange={this.onChangeDropdown} name="ViReflectSeverity" disabled={this.props.disabled} />
                    </div>

                )
        })

        const virefcomment = this.state.Condition.conditionData.map((d, i) => {
            if (this.state.selectedIndex === d.key)
                return (

                    <PtInput key={i} label="Comment" value={d.ViRefComment === null ? '' : d.ViRefComment}
                        onChange={this.onInputChange} name="ViRefComment" disabled={this.props.disabled} />

                )
        })


        const RetroInspectionDate = this.state.Condition.conditionData.map((d, i) => {
            if (this.state.selectedIndex === d.key) {
                return (
                    <PtDateInput key={i} label='Inspection Date'
                        placeholder="Not Available" whichInput="firsttb" inputType="hwy" name="RetroInspectionDate"
                        disabled={this.props.disabled}
                        value={d.RetroInspectionDate ? d.RetroInspectionDate.slice(0, 10) : null}
                        onChange={(date) => this.onChangeDate(date, "RetroInspectionDate")} />
                )
            }
        })

        const RetroRefLegend2 = this.state.Condition.conditionData.map((d, i) => {
            if (this.state.selectedIndex === d.key)
                return (
                    <PtInput key={i} inputType="number" placeholder="Number input"
                        label="Legend (.2)"
                        value={d.RetroRefLegend2 === null ? '' :
                            d.RetroRefLegend2}
                        onChange={this.onInputChange} name="RetroRefLegend2" disabled={this.props.disabled} />
                )
        })

        const RetroRefLegend5 = this.state.Condition.conditionData.map((d, i) => {
            if (this.state.selectedIndex === d.key)
                return (
                    <PtInput key={i} inputType="number" placeholder="Number input"
                        label="Legend (.5)"
                        value={d.RetroRefLegend5 === null ? '' :
                            d.RetroRefLegend5}
                        onChange={this.onInputChange} name="RetroRefLegend5" disabled={this.props.disabled} />
                )
        })
        const RetroRefBkg2 = this.state.Condition.conditionData.map((d, i) => {
            if (this.state.selectedIndex === d.key)
                return (
                    <PtInput key={i} inputType="number" placeholder="Number input"
                        label="Background (.2)"
                        value={d.RetroRefBkg2 === null ? '' : d.RetroRefBkg2}
                        onChange={this.onInputChange} name="RetroRefBkg2" disabled={this.props.disabled} />
                )
        })
        const RetroRefBkg5 = this.state.Condition.conditionData.map((d, i) => {
            if (this.state.selectedIndex === d.key)
                return (
                    <PtInput key={i} inputType="number" placeholder="Number input"
                        label="Background (.5)"
                        value={d.RetroRefBkg5 === null ? '' : d.RetroRefBkg5}
                        onChange={this.onInputChange} name="RetroRefBkg5" disabled={this.props.disabled} />
                )
        })


        return (
            <Container>
                <ScrollArea
                    speed={1}
                    className={!window.mobileAndTabletcheck() ? "area_desktop" : "area_mobile"}
                    contentClassName="content"
                    smoothScrolling={true}>
                    <div style={{ width: 100, float: 'left', }}>
                        <PtSelect key={this.props.pointModel.Condition.conditionData}
                            name='availableActivity' options={this.props.pointModel.Condition.conditionData}
                            defaultVal={this.state.selectedIndex}
                            onChange={this.onChangeIndex} />

                    </div>
                    <strong style={{ float: 'left', paddingTop: 10 }}>of {this.state.Condition.conditionData.length}</strong>

                    {/*<Button style={{ float: 'left', marginTop: 5, marginLeft: 20 }} size='tiny' color='blue' onClick={() => {
                        this.addNewRecord();
                    }}
                        disabled={this.props.disabled}
                    >New</Button>
                    <Button style={{ float: 'left', marginTop: 5, marginLeft: 20, width: 100 }} size='tiny' color='red' onClick={() => {
                        this.deleteRecord(this.state.selectedIndex);
                    }}
                        disabled={this.props.disabled}
                    >Delete</Button>*/}
                    <br />
                    <br />

                    <Accordion fluid style={{ float: 'left' }}>
                        <Accordion.Title className="accordion-title">
                            <div style={{ fontSize: 18 }}><Icon name='dropdown' />
                                Priority</div>
                        </Accordion.Title>
                        <Accordion.Content>

                            <div>{PriorityDate}</div>
                            <div>{PriorityHigh}</div>
                            <div>{PriorityComments}</div>
                            <div>{PriorityKnockdown}</div>
                            <div>{PriorityMissing}</div>
                            <div>{PriorityCondition}</div>
                            <div>{PriorityOther}</div>
                        </Accordion.Content>
                    </Accordion>


                    <Accordion fluid>
                        <Accordion.Title className="accordion-title">
                            <div style={{ fontSize: 18 }}><Icon name='dropdown' />
                                Visual Inspection</div>
                        </Accordion.Title>
                        <Accordion.Content>
                            <div>{VisualInspectDate}</div>
                            <div>{ViPCSeverity}</div>
                            <div>{viPCPosHt}</div>
                            <div>{ViPCGraffiti}</div>
                            <div>{ViPCFade}</div>
                            <div>{ViPCObstructed}</div>
                            <div>{ViPCOther}</div>
                            <div>{viPCcomment}</div>

                            <div>{ViSCSeverity}</div>
                            <div>{ViSCCorrosion}</div>
                            <div>{ViSCStruct}</div>
                            <div>{ViSCBreakaway}</div>
                            <div>{ViSCOther}</div>
                            <div>{viSCcomment}</div>
                            <div>{ViReflectSeverity}</div>
                            <div>{virefcomment}</div>


                        </Accordion.Content>
                    </Accordion>
                    <Accordion fluid>
                        <Accordion.Title className="accordion-title">
                            <div style={{ fontSize: 18 }}><Icon name='dropdown' />
                                Retro Reflectivity Inspection (meter)</div>
                        </Accordion.Title>
                        <Accordion.Content>
                            <div>{RetroInspectionDate}</div>
                            <div>{RetroRefLegend2}</div>
                            <div>{RetroRefLegend5}</div>
                            <div>{RetroRefBkg2}</div>
                            <div>{RetroRefBkg5}</div>

                        </Accordion.Content>
                    </Accordion>
                </ScrollArea>
            </Container>

        )
    }
    onChangeIndex = (e) => {
        const { target } = e;
        const { value } = target;
        this.state.Condition.conditionData.map((panel) => {

            if (panel.key === parseInt(value))
                this.setState({
                    selectedIndex: parseInt(value)
                })
        })
    }


    deleteRecord(index) {
        if (index === 1) {
            alert('Deleting Primary Panel is not Allowed. Please delete the point')
        }
        else if (this.props.pointModel.Condition.conditionData[index - 1].key === this.props.pointModel.Condition.conditionData[this.props.pointModel.Condition.conditionData.length - 1].key) {
            this.props.triggerNeedSave()
            this.props.pointModel.Condition.conditionData = this.props.pointModel.Condition.conditionData.filter(panel => {
                return panel.key !== index
            })
            const tempArray = this.props.pointModel
            console.log(tempArray)
            this.setState({ [this.props.pointModel]: tempArray, selectedIndex: 1 })
        }
        else {
            this.props.triggerNeedSave()
            this.props.pointModel.Condition.conditionData = this.props.pointModel.Condition.conditionData.filter(panel => {
                return panel.key !== index
            })

            this.props.pointModel.Condition.conditionData.map((panel, i) => {
                if (panel.key !== i + 1) {
                    panel.key = panel.key - 1
                    panel.value = panel.value - 1
                    panel.label = 'Sign-' + panel.key
                    panel.PanelType = panel.key
                }
            })
            const tempArray = this.props.pointModel
            console.log(tempArray)
            this.setState({ [this.props.pointModel]: tempArray, selectedIndex: 1 })
        }
    }

    addNewRecord() {
        this.props.triggerNeedSave()
        let label
        let Paneltype
        let panelkey
        let panelvalue
        if (this.props.pointModel.Condition.conditionData.length === 0) {
            label = 'Primary'
            Paneltype = 1
            panelkey = 1
            panelvalue = 1
        }
        else {
            label = 'Sign-' + (parseInt(this.props.pointModel.Condition.conditionData.length) + 1)
            Paneltype = this.props.pointModel.Condition.conditionData[this.props.pointModel.Condition.conditionData.length - 1].key + 1
            panelkey = this.props.pointModel.Condition.conditionData[this.props.pointModel.Condition.conditionData.length - 1].key + 1
            panelvalue = this.props.pointModel.Condition.conditionData[this.props.pointModel.Condition.conditionData.length - 1].key + 1
        }
        if (this.props.pointModel.Condition.conditionData.length > 4)
            alert('More than 5 panels not allowed')
        else
            this.props.pointModel.Condition.conditionData.push(
                {
                    PanelType: Paneltype,
                    PriorityComments: null,
                    PriorityCondition: false,
                    PriorityDate: null,
                    PriorityHigh: false,
                    PriorityKnockdown: false,
                    PriorityMissing: false,
                    PriorityOther: false,
                    RetroInspectionDate: null,
                    RetroRefBkg2: null,
                    RetroRefBkg5: null,
                    RetroRefLegend2: null,
                    RetroRefLegend5: null,
                    ViPCComment: null,
                    ViPCFade: false,
                    ViPCGraffiti: false,
                    ViPCObstructed: false,
                    ViPCOther: false,
                    ViPCPositionHeight: false,
                    ViPCSeverity: null,
                    ViRefComment: null,
                    ViReflectSeverity: null,
                    ViSCBreakaway: false,
                    ViSCComment: null,
                    ViSCCorrosion: false,
                    ViSCOther: false,
                    ViSCSeverity: null,
                    ViSCStruct: false,
                    VisualInspectDate: null,
                    key: panelkey,
                    label: label,
                    value: panelvalue
                })
        const tempArray = this.props.pointModel;
        this.setState({ [this.props.pointModel]: tempArray, selectedIndex: parseInt([this.props.pointModel.Condition.conditionData.length]) })

    }
    onCheckedChange = (e) => {
        const { target } = e;
        const { name, checked } = target;
        this.props.triggerNeedSave();
        this.state.Condition.conditionData.map((panel, i) => {
            if (this.state.selectedIndex === panel.key) {
                panel[name] = checked
                this.props.pointModel.Condition.conditionData[i][name] = checked
            }
        })
    }

    onChangeDropdown = (e) => {
        const { target } = e;
        const { name, value } = target;
        this.props.triggerNeedSave();
        this.state.Condition.conditionData.map((panel, i) => {
            if (this.state.selectedIndex === panel.key) {
                panel[name] = parseInt(value)
                this.props.pointModel.Condition.conditionData[i][name] = parseInt(value)
            }
        })
    }
    onInputChange = (e) => {
        const { name, value } = e.target;
        this.props.triggerNeedSave();
        this.state.Condition.conditionData.map((panel, i) => {
            if (this.state.selectedIndex === panel.key) {
                panel[name] = value
                this.props.pointModel.Condition.conditionData[i][name] = value
            }
        })
    }
    onChangeDate = (date, name) => {
        this.props.triggerNeedSave();
        this.state.Condition.conditionData.map((panel, i) => {
            if (this.state.selectedIndex === panel.key) {
                if (date instanceof Date && !isNaN(date)) {
                    panel[name] = date ? `${date.getFullYear()}-${('0' + (date.getMonth() + 1)).slice(-2)}-${('0' + date.getDate()).slice(-2)}` : null;
                    this.props.pointModel.Condition.conditionData[i][name] = date ? `${date.getFullYear()}-${('0' + (date.getMonth() + 1)).slice(-2)}-${('0' + date.getDate()).slice(-2)}` : null;
                }
            }
        })
    }




}


// WEBPACK FOOTER //
// ./src/layers/tabs/sign/conditionnew.js